import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  applicationType: '',
  documents: [],
  permissionList: [],
  // fetchInfoForm: {},
  fetchedUser: {},
  fetchedCompany: {},
  selectedPermissions: [],
  isDetailsFetched: false,
  isAdmin: true,
  // AddedEmployeeDetails: {},
};
export default function AddCompanyEmployeeReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.ADD_COMPANY_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.ADD_COMPANY_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CHECK_IS_ADMIN:
      return {
        ...state,
        loading: false,
        isAdmin: get(action.payload, 'isAdmin', true),
      };
    case types.CLEAR_ADD_COMPANY_EMPLOYEE_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.FETCH_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        fetchedUser: get(action.payload, 'fetchedUser', {}),
        // AddedEmployeeDetails: get(action.payload, 'AddedEmployeeDetails', {}),
        fetchedCompany: get(action.payload, 'fetchedCompany', {}),
        selectedPermissions: get(action.payload, 'selectedPermissions', {}),
        isDetailsFetched: get(action.payload, 'isDetailsFetched', false),
      };
    case types.FETCH_DOCUMENTS_ADD_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_ADD_COMPANY_EMPLOYEE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.DOWNLOAD_DOCUMENT_ADD_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.ADD_COMPANY_EMPLOYEE_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.ADD_COMPANY_EMPLOYEE_CLEAR_DATA:
      return defaultState;

    case types.UPLOAD_ADD_COMPANY_EMPLOYEE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_ADD_COMPANY_EMPLOYEE_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };

    case types.FETCH_EMPLOYEE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissionList: get(action.payload, 'permissions.result', []),
      };

    // case types.UPDATE_INFO_FORM_FIELD:
    //   return {
    //     ...state,
    //     fetchInfoForm: {
    //       ...state.fetchInfoForm,
    //       [action.payload.name]: action.payload.value,
    //     },
    //   };

    case types.UPDATE_FETCHED_USER_INFO:
      if (action.payload.name === 'eidOrUnified' || action.payload.name === 'birthDate') {
        return {
          ...state,
          isDetailsFetched: false,
          fetchedUser: {
            ...state.fetchedUser,
            [action.payload.name]: action.payload.value,
          },
        };
      }
      return {
        ...state,
        fetchedUser: {
          ...state.fetchedUser,
          [action.payload.name]: action.payload.value,
        },
      };

    case types.UPDATE_ADDED_EMPLOYEE_INFORMATION:
      if (action.payload.name === 'tradeLicenseNumber') {
        return {
          ...state,
          isDetailsFetched: false,
          fetchedCompany: {
            [action.payload.name]: action.payload.value,
          },
          fetchedUser: {
            ...state.fetchedUser,
            userRole: null,
          },
        };
      }

      return {
        ...state,
        fetchedCompany: {
          ...state.fetchedCompany,
          [action.payload.name]: action.payload.value,
        },
      };

    case types.FETCH_EMPLOYEE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isDetailsFetched: true,
        fetchedUser: action.payload,
      };

    case types.FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        isDetailsFetched: true,
        fetchedCompany: action.payload,
      };

    case types.UPDATE_SELECTED_PERMISSION:
      return {
        ...state,
        selectedPermissions: action.payload,
      };

    case types.SAVE_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
}
